import React, {useEffect, useState} from 'react'
import {useCustomPreference} from '../../hooks/use-custom-preference'

const Wazzup = () => {
    const wazzupConfig = useCustomPreference('wazzupConfiguration')
    const [waiting, setWaiting] = useState(true)

    useEffect(() => {
        if (!wazzupConfig || !waiting) return

        const wazzupTimer = setTimeout(() => {
            window?.wazzup?.RenderTags()
            window?.WazzUp?.main()
            setWaiting(false)
        }, 1000)

        return () => clearTimeout(wazzupTimer)
    }, [wazzupConfig, waiting])

    return (
        wazzupConfig && (
            <>
                <div data-testid="wazzup-component" />
                <div
                    className="w-conf"
                    data-code={wazzupConfig.code}
                    data-friend={wazzupConfig.friend}
                />
                <script
                    type="text/javascript"
                    src="//cdn.wazzup.me/libs/widget.js"
                    defer="defer"
                ></script>
                <script
                    type="text/javascript"
                    src="//static.wazzup.me/libs/track.js"
                    defer="defer"
                ></script>
            </>
        )
    )
}

export default Wazzup
